export enum PartnerReviewRejectionReasonType {
  Default = 'default',
  Custom = 'custom',
}
